/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React base styles
import borders from '../borders';
import typography from '../typography';
import colors from '../colors';
import boxShadows from '../boxShadows';

// // Soft UI Dashboard PRO React helper functions
import pxToRem from '../../functions/pxToRem';

const { borderRadius } = borders;
const { fontWeightRegular, fontWeightBold, size } = typography;
const { white, offWhite, dark, primary, secondary, error, success, action } =
    colors;
const { buttonBoxShadow } = boxShadows;

export default {
    '.swal2-container': {
        zIndex: `${9999} !important`,
    },

    '.swal2-compact-dialog': {
        '& .swal2-html-container': {
            margin: 0,
        },
    },

    '.swal2-popup': {
        backgroundColor: offWhite.main,
        borderRadius: `${borderRadius.xl} !important`,

        '& .button, & .swal2-confirm': {
            fontSize: `${size.md} !important`,
            lineHeight: 1.25,
            fontWeight: fontWeightBold,
            borderRadius: `${borderRadius.md} !important`,
            padding: `${pxToRem(12)} ${pxToRem(24)}`,
            margin: pxToRem(3.75),
            textAlign: 'center',
            textTransform: 'none',
            userSelect: 'none',
            backgroundSize: '150% !important',
            backgroundPositionX: '25% !important',
            transition: `all 150ms ease-in`,
            backgroundColor: primary.main,
            color: white.main,
            minHeight: pxToRem(44),
            boxShadow: `${buttonBoxShadow.main} !important`,
            border: 'none',
            cursor: 'pointer',

            '&:hover, &:focus, &:active': {
                boxShadow: `${buttonBoxShadow.stateOf} !important`,
                transform: 'scale(1.02)',
                backgroundImage: 'none !important',
            },

            '& .material-icons-round': {
                fontSize: size.sm,
                marginRight: pxToRem(4),
                verticalAlign: 'middle',
            },
        },

        '& .button.button-success': {
            backgroundColor: success.main,
        },

        '& .button.button-error': {
            backgroundColor: error.main,
        },

        '& .button.button-action': {
            backgroundColor: action.main,
        },

        '& .button.button-cancel': {
            backgroundColor: white.main,
            color: dark.main,
        },

        '& .button-flex': {
            display: 'inline-flex !important',
            alignItems: 'center',
        },

        '& .swal2-image': {
            borderRadius: borderRadius.xl,
            marginBottom: 0,
        },

        '& .swal2-title': {
            fontWeight: fontWeightRegular,
            color: dark.main,
            fontSize: pxToRem(30),
            paddingTop: pxToRem(32),
            lineHeight: pxToRem(40),
        },

        '& .swal2-html-container': {
            fontSize: pxToRem(16),
            color: dark.main,
            lineHeight: pxToRem(24),
        },

        '& .swal2-close': {
            color: secondary.main,
            fontSize: pxToRem(28),
        },
        '& .swal2-input': {
            border: '1px solid rgba(52, 71, 103, 0.2);',
            borderRadius: pxToRem(8),
            background: white.main,
            fontSize: pxToRem(16),
            color: dark.main,
            marginLeft: pxToRem(26),
            '::placeholder': {
                color: 'secondary.main',
                fontSize: pxToRem(16),
                fontWeight: fontWeightRegular,
            },
        },
        '& .swal2-input-label': {
            color: dark.main,
            fontSize: pxToRem(12),
            fontWeight: fontWeightBold,
            textAlign: 'left',
            marginLeft: pxToRem(26),
            marginBottom: pxToRem(-12),
        },
    },
    '& .swal2-icon.swal2-error': {
        color: error.main,
    },
    '& .swal2-radio': {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: offWhite.main,
        color: '#171938',
        fontSize: pxToRem(14),
        fontWeight: fontWeightBold,
        alignItems: 'flex-start',
        paddingLeft: pxToRem(80),
    },
};
